export const clone = obj => structuredClone(obj)
export const sleep = (ms = 1000) => new Promise(r => setTimeout(r, ms))
export const timer = null

// https://www.javascripttutorial.net/array/javascript-remove-duplicates-from-array/
export const dedupe = duplicates => [
  ...new Map(duplicates.map(m => [m.id, m])).values()
]
export const debounce = (func, interval = 2000) => {
  let timer = null

  return async (...args) => {
    if (timer) clearTimeout(timer)

    return new Promise(resolve => {
      timer = setTimeout(async () => {
        const result = await func.apply(this, args)
        resolve(result)
      }, interval)
    })
  }
}

export const hydrate_list = snapshot => {
  const items = []
  if (!snapshot.empty)
    snapshot.forEach(doc => {
      const item = doc.data()
      items.push(item)
    })

  return items
}

export const hydrate_names = snapshot => {
  const names = []
  if (!snapshot.empty)
    snapshot.forEach(doc => {
      names.push(doc.data().name)
    })
  return names
}

/**
 * Checks if a person has any of the specified roles.
 *
 * @param {Object} person - The person object containing access information.
 * @param {Array<string>} roles - The roles to check against the person's access.
 * @returns {boolean} - Returns true if the person has any of the specified roles or is a 'Master Admin', otherwise false.
 */
export const roles_check = (person, roles) => {
  let visibility = false
  if (person?.access) {
    if (person.access.includes('Master Admin')) return true
    if (!roles) return false // an empty roles check can only be true for master admin
    for (const txt of roles)
      if (person.access.includes(txt)) {
        visibility = true
        break
      }
  }
  return visibility
}
